<script>
    import { fly } from 'svelte/transition';
    import { tour } from '../tour';
    
    export let width = 175;
    export let image;
    export let scene;

    function onclick() {
        scene ? tour.loadScene(scene) : tour.loadStartScene();
    }

    let sceneTitle = scene ? 
        tour.getSceneTitle(scene) : 
            tour.getStartSceneTitle();
    </script>
    
    <style>
        div {
            position: absolute;
            left: 20px;
            top: calc(20px + 110px);
            z-index: 750;
            cursor:pointer;
        }

        div:hover img {
            box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.25);
        }
    
        img {
            height: auto;
        }
    
        @media only screen and (max-width: 600px) {
            img{
                max-width: 140px;
            }

            div {
                top: calc(20px + 85px);
            }
        }
    
    </style>
    
    {#if image}
    <div on:click={onclick} transition:fly={{y: -300, duration: 500 }}>
        <img src={image} width={width} alt={'Load '+ sceneTitle}/>
    </div>
    {/if}
    